import { useTranslations } from "@ui/providers/useTranslations";

import type { QuantityInputStatus } from "@jti/core-components/components/QuantityInput";
import { formatPrice } from "@jti/format-price";

export type UseQuantityLimitHelperParams = {
  orderLimitEnabled?: boolean;
  isOrderLimitReached?: boolean;
  disabledAdd?: boolean;
  maxOrderLimit?: number;
  currency?: string;
};

export type QuantityLimitHelper = {
  status: QuantityInputStatus;
  helperText?: string;
};

/**
 * Builds the order-limit hint shown under the cart quantity input.
 * Replaces the hover tooltip previously rendered inside the legacy `@jti/ui` QuantityInput.
 */
export const useQuantityLimitHelper = ({
  orderLimitEnabled = false,
  isOrderLimitReached = false,
  disabledAdd = false,
  maxOrderLimit = 0,
  currency = "",
}: UseQuantityLimitHelperParams): QuantityLimitHelper => {
  const { __ } = useTranslations();

  if (!orderLimitEnabled || disabledAdd || !isOrderLimitReached) {
    return { status: "default" };
  }

  return {
    status: "info",
    helperText: __("com.communication.text_message.friendly_warning", [
      formatPrice({ value: maxOrderLimit, currency }),
    ]),
  };
};
